const _primitiveValue: Symbol = Symbol("Success");

export default class Success {
    static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.valueOf() === _primitiveValue;
    }

    [Symbol.toPrimitive](): any {
        return _primitiveValue;
    }
}
